export default __webpack_public_path__ + "images/61_thumbnail.jpg";